import * as React from 'react'

import Svg, { Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const IconPlaceHolder = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Rect x={3} y={3} width={18} height={18} rx={9} fill={color} />
  </Svg>
)

export default IconPlaceHolder
